<template>
  <v-container fluid fill-height grid-list-xs pa-0>
    <v-layout row wrap align-stretch>
      <v-form v-model="valid" style="width: 100%;">
        <v-layout row wrap justify-center>
          <v-flex
            xs12
            sm6
            md3
            lg3
          >
            <v-flex xs12>
              <b>Vendedor</b>
            </v-flex>
            <v-flex xs12>
                <v-select
                  :items="postos"
                  item-text="nome_fantasia"
                  label="Selecione um posto"
                  item-value="cnpj"
                  v-model="data.posto"
                >
                  <template v-slot:selection="data">
                    <div class="subheading">{{ data.item.nome_fantasia }}</div>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title>{{ data.item.nome_fantasia }}</v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.cnpj }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-select>
              </v-flex>
          </v-flex>
          <v-divider
            :vertical="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
          ></v-divider>
          <v-flex
            xs12
            :sm6="empresa && empresa.tipo_empresa !== 1"
            :sm12="empresa && empresa.tipo_empresa === 1"
            :md8="empresa && empresa.tipo_empresa !== 1"
            :md10="empresa && empresa.tipo_empresa === 1"
            :lg6="empresa && empresa.tipo_empresa !== 1"
            :lg9="empresa && empresa.tipo_empresa !== 1"
          >
            <v-flex xs12>
              <b>Dados da Compra:</b>
            </v-flex>
            <v-layout justify-space-around wrap>
              <v-flex xs12 sm6 md6>
                <v-select
                  :items="[
                    { text: 'Todos', value: null },
                    { text: 'Lido', value: false },
                    { text: 'Aguandando Leitura', value: true }
                  ]"
                  label="Status"
                  v-model="data.disponivel"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Código"
                  class="pr-3"
                  v-model="data.codigo"
                  hint="Código da compra"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-select
                  :items="[
                    {
                      title: 'Dia',
                      value: 'dia'
                    },
                    {
                      title: 'Mês',
                      value: 'mes'
                    },
                    {
                      title: 'Intervalo',
                      value: 'custom'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  v-model="selectOpcoes"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-menu
                  ref="menuDataInicial"
                  v-model="menuDataInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-combobox
                      v-if="data.custom"
                      v-model="data.intervalo_relatorio"
                      label="Dias"
                      multiple
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                    <v-combobox
                      v-else-if="data.dia"
                      v-model="data.data_relatorio"
                      label="Dia"
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      @blur="date = parseDate(data.data_relatorio)"
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                    <v-combobox
                      v-else
                      v-model="data.mes_relatorio"
                      label="Mes"
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      @blur="month = parseDate(data.mes_relatorio)"
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                  </template>
                  <v-date-picker v-show="data.custom" multiple v-model="dates" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
                  <v-date-picker v-show="data.dia" v-model="date" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
                  <v-date-picker v-show="data.mes" v-model="month" type="month" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            sm12
            md1
            style="
              justify-content: center;
              align-items: center;
              display: flex;
            "
          >
            <v-flex
              xs12
              sm6
              md12
            >
              <v-btn
                :fab="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                :block="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
                dark
                small
                color="primary"
                @click="carregarRelatorio(true, false)"
              >
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex
              xs12
              sm6
              md12
            >
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :icon="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                    :block="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
                    v-on="on"
                    small
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    @click="print()"
                  >
                    <v-list-item-action>
                      <v-icon>print</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>Imprimir relatório</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="carregarRelatorio(true, true)"
                  >
                    <v-list-item-action>
                      <v-icon>cloud_download</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>Exportar relatório</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 class="print">
        <div class="pb-3 pt-5">
          <v-layout row>
            <h2> Relatório de Compras</h2>
            <v-spacer></v-spacer>
          </v-layout>
          <hr/>
        </div>
         <v-card>
          <v-data-table
            :items="compras"
            hide-default-footer
            :options.sync="pagination"
            :loading="loading"
          >
            <template v-slot:item="props">
              <tr>
                <td class="text-xs-center px-0" style="width: 60px"  v-if="headersVisible.item">
                  <template v-if="props.item.combustivel">
                    <v-tooltip class="hidden-print-only" :color="props.item.combustivel.color" top>
                        <template v-slot:activator="{ on }">
                            <span class="hidden-print-only" v-on="on">
                                <svg-filler :path="require(`@/assets/combs/${props.item.combustivel.icone}.svg`)" width="40px" height="40px" :fill="props.item.combustivel.color"/>
                            </span>
                        </template>
                        <span>{{props.item.combustivel.nome}}</span>
                    </v-tooltip>
                    <span class="hidden-screen-only">{{props.item.combustivel.nome}}</span>
                  </template>
                  <template v-else-if="props.item.pedido">
                    <v-tooltip class="hidden-print-only" top>
                        <template v-slot:activator="{ on }">
                            <span class="hidden-print-only" v-on="on">
                                <v-icon color="success">attach_money</v-icon>
                            </span>
                        </template>
                        <span>Compra de Item</span>
                    </v-tooltip>
                    <span class="hidden-screen-only">Compra de Item</span>
                  </template>
                </td>
                <td class="text-xs-left" v-if="headersVisible.codigo">
                  <b>{{ props.item.codigo }}</b>
                </td>
                <td class="text-xs-left" v-if="headersVisible.data_compra">
                  <template v-if="props.item.data_compra">
                    {{ props.item.data_compra | formatDate('DD/MM/YYYY') }}
                  </template>
                </td>
                <td class="text-xs-left" v-if="headersVisible.comprador">
                  <template v-if="props.item.empresa && props.item.empresa.nome_fantasia">
                    Empresa {{`${props.item.empresa.nome_fantasia}` }}
                    <div><strong>{{props.item.empresa.cnpj}}</strong></div>
                  </template>
                  <template v-else-if="props.item.cliente && props.item.cliente.pessoa">
                    Cliente {{`${props.item.cliente.pessoa.nome}` }}
                    <div><strong>{{props.item.cliente.pessoa.id_pessoa}}</strong></div>
                  </template>
                  <template v-else>
                    Não encontrado
                  </template>
                </td>
                <td class="text-xs-left" v-if="headersVisible.vendedor">
                  <template v-if="props.item.posto">
                    Posto: {{  props.item.posto.nome_fantasia }}
                    <div><strong>{{ props.item.posto.cnpj }}</strong></div>
                  </template>
                </td>
                <td class="text-xs-left" v-if="headersVisible.valor_total">
                  <template v-if="props.item.valor_total">
                    {{ props.item.valor_total | currency({ fractionCount: 2 }) }}
                  </template>
                  <template v-else-if="props.item.valor">
                    {{ props.item.valor | currency({ fractionCount: 2 }) }}
                  </template>
                </td>
                <td class="text-xs-center" v-if="headersVisible.desconto">
                  {{props.item.desconto || 0}}%
                </td>
                <td class="text-xs-left" v-if="headersVisible.valor">
                  {{ props.item.valor | currency({ fractionCount: 2 }) }}
                </td>
                <td class="text-xs-left" v-if="headersVisible.data_inativado">
                  <template v-if="props.item.data_inativado">
                    {{ props.item.data_inativado | formatDate('DD/MM/YYYY') }}
                  </template>
                </td>
                <td class="text-xs-center" v-if="headersVisible.confirmada">
                  <v-tooltip v-if="props.item.confirmado" top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="teal">done_all</v-icon>
                      </template>
                      <span>Pagamento efetuado</span>
                  </v-tooltip>
                  <v-tooltip v-else top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="red">close</v-icon>
                      </template>
                      <span>Pagamento não efetuado</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-center" v-if="headersVisible.disponivel">
                  <v-tooltip v-if="!props.item.disponivel" top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="teal">check_circle</v-icon>
                      </template>
                      <span>Leitura realizada</span>
                  </v-tooltip>
                  <v-tooltip v-else top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="red">cancel</v-icon>
                      </template>
                      <span>Leitura não realizada</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:header>
              <tr>
                <th class="text-xs-left px-4 pa-4" v-if="headersVisible.item">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.item = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                </th>
                <th class="text-xs-left px-3 pa-4" v-if="headersVisible.codigo">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.codigo = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  Código
                </th>
                <th class="text-xs-left px-3 pa-4" v-if="headersVisible.data_compra">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_compra = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  Data
                </th>
                <th class="text-xs-left px-3 pa-4" v-if="headersVisible.comprador">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.comprador = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  Comprador
                </th>
                <th class="text-xs-left px-3 pa-4" v-if="headersVisible.vendedor">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.vendedor = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  Vendedor
                </th>
                <th class="text-xs-left px-3 pa-4" v-if="headersVisible.valor_total">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor_total = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  Valor Total (R$)
                </th>
                <th class="text-xs-center px-3 pa-4" v-if="headersVisible.desconto">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.desconto = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  Desconto
                </th>
                <th class="text-xs-right px-3 pa-4" v-if="headersVisible.valor">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  Valor Pago (R$)
                </th>
                <th class="text-xs-left  px-3 pa-4" v-if="headersVisible.data_compra">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_compra = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  Data da Leitura
                </th>
                <th class="text-xs-center px-4 pa-4" v-if="headersVisible.disponivel">
                  <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.disponivel = false">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn fab x-small color="success" @click="carregarRelatorio(true, true)">
                        <v-icon v-on="on">cloud_download</v-icon>
                      </v-btn>
                    </template>
                    <span>Exportar relatório</span>
                  </v-tooltip>
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-card>
        <div class="text-xs-center px-4 ma-4">
          <v-pagination
            v-model="pagination.page"
            :length="pages"
            circle
            class="ma-4"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-footer
      app
      style="background: transparent;"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="compras.length">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            VALOR: {{ total_recebido | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 20
      },
      data: {
        disponivel: false,
        posto: null,
        codigo: null,
        dia: true,
        custom: false,
        mes: false,
        data_relatorio: moment().format('DD/MM/YYYY'),
        mes_relatorio: null,
        intervalo_relatorio: [],
        recebidos: false
      },
      itens: [],
      valid: false,
      combustivel: '',
      filtro: 'todos',
      editando: false,
      menuDataInicial: false,
      date: moment().format('YYYY-MM-DD'),
      month: new Date().toISOString().substr(0, 10),
      dates: [],
      headersVisible: {
        desconto: true,
        item: true,
        data_compra: true,
        data_inativado: true,
        confirmada: true,
        valor: true,
        valor_total: true,
        disponivel: true,
        codigo: true,
        comprador: true,
        vendedor: true,
        usuario_utilizador: true
      },
      today: null,
      selectOpcoes: 'dia',
      postos: [],
      total_relatorio_vouchers: 0,
      total_recebido: 0,
      compras: [],
      search: '',
      total_itens: 0
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    empresa () {
      return this.$store.getters.empresa
    },
    ready () {
      return !!this.empresa
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.total_itens == null
      ) return 0

      return Math.ceil(this.total_itens / this.pagination.rowsPerPage)
    }
  },
  watch: {
    empresa (val) {
      if (val !== null && val !== undefined) {
        this.carregarPostos()
      }
    },
    filtro (val) {
      this.data.recebidos = false
      if (val === 'recebidos') {
        this.data.recebidos = true
      }
    },
    date (val) {
      if (val) {
        this.data.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.data.mes_relatorio = this.formatDate(this.month)
      }
    },
    selectOpcoes (val) {
      this.limparOpcoes()
      if (val === 'dia') {
        this.data.dia = true
        this.data.data_relatorio = this.formatDate(this.date)
      } else if (val === 'custom') {
        this.data.custom = true
        this.data.data_relatorio = this.formatDate(this.date)
      } else if (val === 'mes') {
        this.data.mes = true
        this.data.mes_relatorio = this.formatDate(this.month)
      }
    },
    'pagination.page': {
      handler (val, oldval) {
        if (this.empresa && val !== oldval) this.carregarRelatorio(false, false)
      },
      deep: true
    }
  },
  mounted () {
    this.today = new Date().setHours(0, 0, 0, 0)
  },
  beforeMount () {
    if (this.ready) {
      this.carregarPostos()
    }
  },
  methods: {
    print () {
      window.print()
    },
    formatDate (date) {
      if (!date) return null

      if (this.data.dia || this.data.custom) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.data.dia || this.data.custom) {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    limparOpcoes () {
      this.data.dia = false
      this.data.custom = false
      this.data.mes = false
    },
    carregarRelatorio (isBtn, isExport) {
      const filtro = {
        page: isBtn ? 1 : this.pagination.page,
        sindicato: this.empresa.cnpj,
        confirmado: true
      }
      if (this.data.posto !== null && this.data.posto !== undefined) {
        filtro.posto = this.data.posto
      } else {
        this.$store.dispatch('setError', 'Você precisa selecionar um posto primeiro.')
        return
      }
      if (this.data.disponivel !== null && this.data.disponivel !== undefined) {
        filtro.disponivel = this.data.disponivel
      }
      if (this.data.codigo) {
        filtro.codigo__iexact = this.data.codigo
      }
      if (this.data.disponivel === false) {
        if (this.data.custom && this.data.intervalo_relatorio && this.data.intervalo_relatorio.length === 2) {
          filtro.data_inativado__gte = this.data.intervalo_relatorio[0]
          filtro.data_inativado__lte = this.data.intervalo_relatorio[1]
        } else if (this.data.dia && this.date) {
          filtro.data_inativado = this.date.split('-').reverse().join('/')
        } else if (this.data.mes && this.month) {
          const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
          const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)

          filtro.data_inativado__gte = initialDate.toISOString().substr(0, 10).split('-').reverse().join('/')
          filtro.data_inativado__lt = finalDate.toISOString().substr(0, 10).split('-').reverse().join('/')
        }
      } else {
        if (this.data.custom && this.data.intervalo_relatorio && this.data.intervalo_relatorio.length === 2) {
          filtro.data_compra__gte = this.data.intervalo_relatorio[0]
          filtro.data_compra__lte = this.data.intervalo_relatorio[1]
        } else if (this.data.dia && this.date) {
          filtro.data_compra = this.date.split('-').reverse().join('/')
        } else if (this.data.mes && this.month) {
          const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
          const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)

          filtro.data_compra__gte = initialDate.toISOString().substr(0, 10).split('-').reverse().join('/')
          filtro.data_compra__lt = finalDate.toISOString().substr(0, 10).split('-').reverse().join('/')
        }
      }
      if (isExport) {
        this.$store.dispatch('exportarCompras', filtro)
        return
      }
      this.$store.dispatch('comprasPorPosto', filtro).then(json => {
        this.compras = json.results.compras
        this.total_relatorio_vouchers = json.results.valor_total
        this.total_recebido = json.results.valor
        this.total_itens = json.count
      })
    },
    carregarPostos () {
      const data = {
        cnpj_empresa: this.empresa.cnpj,
        rede_sindicato_id: this.empresa.rede_sindicato
      }
      this.$store.dispatch('pegarPostos', data).then(json => {
        this.postos = json || []
        if (this.postos.length > 0) {
          this.data.posto = this.postos[0].cnpj
        }
      })
    },
    dataSelecionada () {
      if (this.data.custom) {
        if (this.dates.length === 3) {
          const day1 = this.dates[0]
          const day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.data.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    }
  }
}
</script>
